import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import AnnotatorSidebar from '../components/AnnotatorSidebar';
import ErrorBoundary from '../components/ErrorBoundary';

export default function AnnotatorLayout() {
  // Match admin: dark-editorial brand theme. Annotators see the same
  // warm-ink surface as the landing + login, so the marketplace experience
  // feels like one continuous voice from first-click through working.
  // No cleanup-restore: prev/cleanup pattern leaks theme on sibling-route
  // transitions. Each layout sets its theme on mount; next mount overrides.
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'admin-dark');
  }, []);

  return (
    <div className="app">
      <AnnotatorSidebar />
      <main className="main-content annotator-main">
        <ErrorBoundary label="Annotator Page">
          <div className="annotator-page">
            <Outlet />
          </div>
        </ErrorBoundary>
      </main>
    </div>
  );
}
